module.exports = __webpack_public_path__ + "static/media/placeholder.09b77349.jpg";